import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PaymentPopup from './PaymentPopup'
import PaymentPage from './PaymentPage';
import Welcome from '../../../components/assets/images/ibcImages/welcomecard.jpg';
import Money from '../../../components/assets/images/ibcImages/moneycard.jpg';
import Shop from '../../../components/assets/images/ibcImages/shopcard.jpg';
import Funding from '../../../components/assets/images/ibcImages/fundingcard.jpg';
import Done from '../../../components/assets/images/ibcImages/donecard.jpg';


const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: '0 auto',
    borderRadius: 15,
    overflow: 'hidden',
    marginTop: 30,
  },
  packageCardBg: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
  },
  eyebrow:{
    background: '#d1e9f8',
    marginBottom: 30,
    width: 'max-content',
    color: '#59b1e6',
    padding: '3px 10px',
    borderRadius: 25,
    fontSize: 12,
  },
  packageCardContent: {
    position: 'relative',
    minHeight:250,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  heading: {
    maxWidth: '70%',
    color: '#fff',
    fontWeight: 'bold',
  },
  details: {
    maxWidth: '70%',
    color: '#fff',
  },
  packagePrice:{
    fontWeight: 'bold',
    color: '#fff',
    fontSize: 24,
    marginTop: 4,
  },
  button: {
    alignSelf: 'flex-end',
  },
plansSection: {
  marginTop: 10,   // 🔥 reduce top spacing
  paddingTop: 10,
  textAlign: 'center',
},


plansWrapper: {
  display: 'flex',
  justifyContent: 'center',
  gap: 40,
  marginTop: 30,
  width: '100%',
  maxWidth: 1200,
  marginLeft: 'auto',
  marginRight: 'auto',

  '@media (max-width: 900px)': {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    padding: '0 16px',
  },
},


planCard: {
  position: 'relative',
  overflow: 'visible',
  flex: '0 0 460px',     // 👈 fixed desktop width
  borderRadius: 28,
  padding: '40px 35px',
  textAlign: 'center',
  background: '#fff',
  transition: 'all 0.3s ease',
  border: '2px solid transparent',
  boxShadow: `
    0 4px 12px rgba(0, 0, 0, 0.04),
    0 12px 30px rgba(0, 0, 0, 0.06)
  `,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  '&:hover': {
    border: '2px solid #1ABC9C',
    transform: 'translateY(-6px)',
  },

  '@media (max-width: 900px)': {
    flex: 'unset',
    width: '100%',
    maxWidth: 420,
    padding: '28px 24px',
  },
},


planPrice: {
  fontSize: 40,
  fontWeight: 700,
  margin: '10px 0 20px',
  color: '#0E6655',

    '@media (max-width: 900px)': {
    fontSize: 32,
  },
},



planDescription: {
  fontSize: 16,
  color: '#555',
  marginBottom: 40,
},

planButton: {
  borderRadius: 30,
  padding: '16px 40px',
  fontSize: 15,
  fontWeight: 600,
  width: 200,
  margin: '0 auto',
  color: '#fff',
  background: 'linear-gradient(135deg, #0E6655 0%, #1ABC9C 100%)',
  boxShadow: '0 6px 20px rgba(14, 102, 85, 0.25)',
  transition: 'all 0.3s ease',

  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 10px 28px rgba(14, 102, 85, 0.35)',
  },
},
  paymentPanel: {
    maxWidth: 380,
    width: 380,
    flex: '0 0 380px',
    borderRadius: 15,
    background: '#fff',
    padding: 24,
    boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
  },

  paymentPanelWrapper: {
    display: 'flex',
    gap: 24,
    justifyContent: 'center',
    alignItems: 'stretch',
    flexWrap: 'nowrap',
    marginTop: 30,
  },
  paymentInner: {
    width: '100%',
    maxWidth: 360,
    margin: '0 auto',
  },
  planTitle: {
  fontWeight: 600,
  letterSpacing: 1,
  textTransform: 'uppercase',
  position: 'relative',
  paddingBottom: 14,
  marginBottom: 24,
  display: 'inline-block',

  '&::after': {
    content: '""',
    position: 'absolute',
    left: '50%',
    bottom: 0,
    transform: 'translateX(-50%)',
    width: 72,              // 🔴 SAME underline length for all
    height: 3,
    backgroundColor: '#DC281E',
    borderRadius: 2,
  },
},
planBadge: {
  position: 'absolute',
  top: 16,
  right: 20,
  background: 'linear-gradient(135deg, #0E6655 0%, #1ABC9C 100%)',
  color: '#fff',
  padding: '6px 16px',
  borderRadius: 50,
  fontSize: 12,
  fontWeight: 600,
  zIndex: 10,
  boxShadow: '0 4px 12px rgba(14, 102, 85, 0.25)',

  '@media (max-width: 900px)': {
    top: -14,          // 👈 move above card
    right: '50%',
    transform: 'translateX(50%)',
  },
},

gstText: {
  fontSize: 14,
  fontWeight: 500,
  marginLeft: 6,
  color: '#666',
},
mobileHeading: {
  '@media (max-width: 900px)': {
    fontSize: 28,
  },
},

highlightText: {
  background: 'linear-gradient(135deg, #0E6655 0%, #1ABC9C 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
},
});
function getSteps() {
  return ['Step 1', 'Step 2', 'Step 3', 'Choose Plan'];
}

export default function PackageCard(props) {
  const classes = useStyles();

  const { packageDetails, userDetails } = props;
  const [payment, setPayment] = React.useState(false);
  const [selectedPlan, setSelectedPlan] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const getStepContent = (step) => {
    switch (step) {
        case 0:
            return (<Card className={classes.root} component="div">
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={Welcome}
                  alt="Package image"
                  className={classes.packageCardBg}
                />
                <CardContent className={classes.packageCardContent}>
                  <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                  Welcome <br></br>Let’s get a membership.
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p" className={classes.details}>
                    {packageDetails?.details || 'Become a member to the club of entrepreneurs and investors'}
                  </Typography>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                  >
                      Continue
                  </Button>
                </CardContent>
              </CardActionArea>
              
            </Card>);
        case 1:
            return (<Card className={classes.root} component="div">
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={Money}
                  alt="Package image"
                  className={classes.packageCardBg}
                />
                <CardContent className={classes.packageCardContent}>
                  <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                  Grow your business with us
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p" className={classes.details}>
                  We aim to provide business opportunities to existing and upcoming businesses.
                  </Typography>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                  >
                      Continue
                  </Button>
                </CardContent>
              </CardActionArea>
              
            </Card>);
        case 2:
            return (<Card className={classes.root} component="div">
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={Shop}
                  alt="Package image"
                  className={classes.packageCardBg}
                />
                <CardContent className={classes.packageCardContent}>
                  {/* <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                    Get funding for your business
                  </Typography> */}
                  <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                    {packageDetails?.heading || 'Get funding for your business'}
                  </Typography>
                  {/* <Typography className={classes.packagePrice}>
                    {packageDetails?.price && (
                      <Typography className={classes.packagePrice}>
                        {packageDetails.price}
                      </Typography>
                    )}
                  </Typography> */}

                  <Typography variant="body2" color="textSecondary" component="p" className={classes.details}>
                    We will help to find the best investment option for your business.
                  </Typography>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                  >
                      Continue
                  </Button>
                </CardContent>
              </CardActionArea>
            </Card>);
        case 3:
  return (
  // <div style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)' }}>
    <div className={classes.plansSection}>

      
      <Typography
  variant="h3"
  style={{
    fontWeight: 700,
  }}
  className={classes.mobileHeading}
>

        Membership{' '}
        <span className={classes.highlightText}>Plans</span>
      </Typography>


      <Typography style={{ marginTop: 10, color: '#666' }}>
        Choose the plan that best fits your business growth needs.
      </Typography>

      <div className={classes.plansWrapper}>
        {[
          {
            id: 'VIP',
            heading: 'VIP Membership',
            price: 25000,
            description:
              'Premium benefits with priority visibility and advanced tools.',
            badge: 'Most Popular',
          },
          {
            id: 'STANDARD',
            heading: 'Standard Membership',
            price: 15000,
            description:
              'Essential tools with weekly meets and community access.',
            badge: 'Great Value'
          },
        ].map((plan) => (
          <Card key={plan.id} className={classes.planCard}>
            {plan.badge && (
              <div className={classes.planBadge}>{plan.badge}</div>
)}

            
            <Typography variant="h5" style={{ fontWeight: 600, marginBottom: 10 }}> {plan.heading}</Typography>

            <div className={classes.planPrice}>
              ₹{plan.price.toLocaleString()}
              <span className={classes.gstText}> +18% GST</span>
            </div>

            <div className={classes.planDescription}>
              {plan.description}
            </div>

            <Button
              variant="contained"
              color="primary"
              className={classes.planButton}
              onClick={() => {
                setSelectedPlan({
                  id: plan.id,
                  heading: plan.heading,
                  amount: plan.price,
                  currency: 'INR',
                });
                setPayment(true);
              }}
            >
              Choose Plan

            </Button>

          </Card>
        ))}
      </div>
    </div>
    // </div>
  );

        default:
            return 'Unknown step';
    }
}


  return (
    <div>
      <div>
          <div>{getStepContent(activeStep)}</div>
      </div>
      {selectedPlan && (
        <PaymentPopup
          defaultState={payment}
          componentToPassDown={
            <PaymentPage
              userDetails={userDetails}
              packageDetails={selectedPlan}
              handleClose={() => {
                setPayment(false);
                setSelectedPlan(null);
              }}
            />
          }
          handleClose={() => {
            setPayment(false);
            setSelectedPlan(null);
          }}
        />
      )}

    </div>
  );
}
